import { AfterViewInit, Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MeteringPointService } from '@app/api/dmc';
import { FormApiService } from '@app/core/services/form-api.service';
import { InputGroupComponent } from '@shared/components/input/input-group/input-group.component';
import { LabelDirective } from '@shared/components/input/label/label.directive';
import { InputDirective } from '@shared/components/input/input/input.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { HasUnsavedChanges } from '@app/core/guards/unsaved-changes.guard';

@Component({
  selector: 'app-dashboard-request-data',
  imports: [
    ReactiveFormsModule,
    InputGroupComponent,
    LabelDirective,
    InputDirective,
    TranslatePipe
  ],
  templateUrl: './dashboard-request-data.component.html',
  styleUrl: './dashboard-request-data.component.css'
})
export class DashboardRequestDataComponent implements AfterViewInit, HasUnsavedChanges {
  public hasUnsavedChanges(): boolean {
    return this.form.dirty;
  }

  public form: FormGroup = new FormGroup({
    meteringPointIdentification: new FormControl(null, Validators.required),
    validFrom: new FormControl(null, Validators.required),
  });

  public element?: any;

  constructor(
    private readonly formApiService: FormApiService,
    private readonly meteringPointService: MeteringPointService,
  ) {
  }

  public ngAfterViewInit(): void {
    if (this.element?.meteringPointIdentification) {
      this.form.get('meteringPointIdentification')?.setValue(this.element.meteringPointIdentification);
    }
  }

  public submit(): void {
    if (!this.element?.meteringPointIdentification) return;

    this.form.get('meteringPointIdentification')?.setValue(this.element.meteringPointIdentification);

    this.formApiService.submit(this.form,
      (data) => this.meteringPointService.meteringPointRequestMasterDataPost(data),
      {
        closeModal: true,
        successMessage: 'dashboard.request.success'
      }
    )
  }

}
